// This file is the stylesheet used for PDF component. It is not converted to any css at all
import { StyleSheet } from '@react-pdf/renderer';

export default StyleSheet.create({
  page: {
    paddingTop: '43mm',
    paddingBottom: '43mm',
    paddingLeft: '15mm',
    paddingRight: '15mm',

  },
  day_section: {
    marginTop: 10,
    width: '100%',
    heading: {
      backgroundColor: '#dedede',
      fontFamily: 'OpenSansBold',
      fontSize: '11pt',
      padding: '4mm 5mm',
      borderRadius: '3',
    },
  },
  schedule: {
    paddingTop: '3mm',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  schedule_ampm: {
    fontSize: '11pt',
    heading_ampm: { fontFamily: 'OpenSansBold' },
    container_ampm: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    timetext: {
      fontFamily: 'OpenSansRegular',
      textAlign: 'right',
      width: '0.4in',
      paddingTop: '1mm',
    },

  },

  // -----------------------------------HEADER
  header: {
    width: '100%',
    height: '43mm',
    position: 'absolute',
    top: 0,
    left: '15mm',
    display: 'flex',
    flexDirection: 'row',

    paddingTop: '22mm',

    transport_icon: {
      width: '16mm',
      height: '16mm',
    },
    text_section: {
      marginLeft: '3mm',
      marginRight: '3mm',
      width: '138mm',

    },
    routetext: {
      fontFamily: 'OpenSansBold',
      fontSize: '18pt',
    },
    stoptext: {
      fontFamily: 'OpenSansRegular',
      fontSize: '18pt',
    },
    at_logo: {
      width: '20mm',
      height: '20mm',
    },
  },

  // -----------------------------------FOOTER
  footer: {
    width: '100%',
    height: '43mm',
    position: 'absolute',
    bottom: 0,
    left: '15mm',
    display: 'flex',
    flexDirection: 'row',
    paddingTop: '5mm',
    borderTop: '1 solid #dedede',

    text_section: {
      width: '100mm',
      marginRight: '15mm',
    },
    title: {
      fontFamily: 'OpenSansBold',
      fontSize: '10pt',
    },
    content: {
      fontFamily: 'OpenSansRegular',
      fontSize: '10pt',
    },

    apple_badge: {
      width: '28mm',
      height: '10mm',
      float: 'right',
    },
    google_badge: {
      marginLeft: '5mm',
      width: '31mm',
      height: '10mm',
      float: 'right',
    },

  },
});
